import { FC } from 'react';
import { Content, PageSectionHeader } from '@/components';

/** Placeholder: routed and reachable, but not built yet. */
const CreativeLibrary: FC = () => (
  <>
    <PageSectionHeader>Creative Library</PageSectionHeader>
    <Content>
      <p>This page has not been built yet.</p>
    </Content>
  </>
);

export default CreativeLibrary;
